import React, { useState } from 'react';
import { Button, Alert, Spinner } from 'reactstrap';
import { useMutation } from '@apollo/react-hooks';
import { TOGGLE_CRAZY_HEART_FIRMWARE } from '../../../mutation/mutation';
import { GET_BOX_DATA } from '../../../query/query';

const toggleCrazyHeartFirmwareMutationFunction = ({ boxId }) => useMutation(
  TOGGLE_CRAZY_HEART_FIRMWARE, {
    update(cache, { data: { savToggleCrazyHeartFirmware: hasCrazyHeartFirmware } }) {
      if (typeof hasColor !== 'boolean') return;
      const { savGetBoxData } = cache.readQuery({
        query: GET_BOX_DATA,
        variables: { boxId },
      });
      if (!savGetBoxData.versions) savGetBoxData.versions = {};
      if (hasCrazyHeartFirmware) {
        savGetBoxData.versions.testGroup = 'other';
        savGetBoxData.versions.targetVersion = '4.0.54';
        cache.writeQuery({ query: GET_BOX_DATA, variables: { boxId }, data: { savGetBoxData } });
      } else {
        savGetBoxData.versions.testGroup = undefined;
        savGetBoxData.versions.targetVersion = '4.0.55';
      }
    },
  },
);

export default ({ boxId, hasCrazyHeartFirmware, refetchBox }) => {
  const [toggleCrazyHeartFirmwareMutation] = toggleCrazyHeartFirmwareMutationFunction({ boxId });
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleCrazyHeartFirmware = async () => {
    setError(false);
    setLoading(true);
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(
      `⚠️ Are you sure to ${hasCrazyHeartFirmware ? 'des' : ''}activate crazy heart firmware on this box ?`,
    );
    if (!confirm) {
      setLoading(false);
      return;
    }
    try {
      await toggleCrazyHeartFirmwareMutation({ variables: { boxId } });
      await refetchBox();
      setLoading(false);
    } catch (e) {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <div>
      {loading
        ? (<Spinner color="primary" />)
        : (
          <Button
            type="submit"
            color="primary"
            onClick={toggleCrazyHeartFirmware}
          >
            {`${hasCrazyHeartFirmware ? 'Desactivate' : 'Activate'} Crazy Heart Special Version`}
          </Button>
        )}
      {error && (
        <Alert color="danger">
          An error occured when trying to toggle the crazy heart firmware on this box.
        </Alert>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/infos/toggle-crazy-heart-firmware.js